export * from '@material-ui/core/withWidth'
export default from '@material-ui/core/withWidth'
